<template>
    <basic-container>
        <avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" v-model="form" :page.sync="page"
            :permission="permissionList" @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset"
            @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange"
            @refresh-change="refreshChange" @on-load="onLoad">
<!--            <template slot="menuLeft">-->
<!--                <el-button type="danger" size="small" icon="el-icon-delete" plain @click="handleDelete">删 除-->
<!--                </el-button>-->
<!--            </template>-->
            <template slot-scope="scope" slot="menu">
<!--                <el-button type="text" icon="el-icon-edit-outline" size="small"-->
<!--                    @click.stop="handleDesign(scope.row.fileName)">设计-->
<!--                </el-button>-->
                <el-button type="text" icon="el-icon-view" size="small" @click.stop="handlePreview(scope.row.fileName)">预览
                </el-button>
<!--                <el-button type="text" icon="el-icon-view" size="small" @click.stop="copyPreview(scope.row.name)">复制链接-->
<!--                </el-button>-->
            </template>
            <template slot-scope="{ row }" slot="name">
                <el-tag style="cursor: pointer" @click="handlePreview(row.name)">{{row.name}}</el-tag>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
import { getList, remove } from "@/api/sys/sysReport";
import { mapGetters } from "vuex";

export default {
    data () {
        return {
            form: {},
            selectionList: [],
            query: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            option: {
                height: 'auto',
                calcHeight: 30,
                tip: false,
                searchShow: true,
                searchMenuSpan: 6,
                menuWidth:280,
                border: true,
                index: true,
                selection: true,
                viewBtn: true,
                dialogClickModal: false,
                column: [
                    {
                        label: "文件名",
                        prop: "fileName",
                        search: true,
                        slot: true,
                    },
                    {
                      label: "报表名称",
                      prop: "reportName",
                    }
                    //,
                    //{
                     //   label: "创建时间",
                     //   prop: "createTime",
                    //},
                    //{
                    //    label: "更新时间",
                    //    prop: "updateTime",
                    //}
                ]
            },
            data: []
        };
    },
    computed: {
        // ...mapGetters(["userInfo", "permission"]),
        permissionList () {
            return {
                addBtn: false,
                viewBtn: false,
                delBtn: false,
                editBtn: false
            };
        },
        ids () {
            let ids = [];
            this.selectionList.forEach(ele => {
                ids.push(ele.reportId);
            });
            return ids.join(",");
        }
    },
    methods: {
        handlePreview (name) {
          window.open("https://www.taclmy.com:10081/ureport/preview?_u=mysql:"+name, '_blank');
             // this.$router.$avueRouter.name ="报表预览";
             //    this.$router.push({
             //        path: this.$router.$avueRouter.getPath({
             //        name: "报表预览",
             //        src: "/report/reportView/"+name
             //        }, {}),
             //        query: {type:1}
             //    });
        },
        handleDesign (name) {
            // this.$router.$avueRouter.name ="报表设计";
            //     this.$router.push({
            //         path: this.$router.$avueRouter.getPath({
            //         name: "报表设计",
            //         src: "/report/reportView/"+name
            //         }, {}),
            //         query: {type:2}
            //     });

        },
        // copyPreview(name){
        //     this.$Clipboard({
        //         text:`${process.env.VUE_APP_BASE_URL}/ureport/preview?_u=report-` + name
        //     }).then(()=>{
        //     this.$message.success('复制成功')
        //     }).catch(()=>{
        //     this.$message.error('复制失败')
        //     });
        // },
        //rowDel (row) {
        //    this.handleDelete(null, row.reportId)
        //},
        searchReset () {
            this.query = {};
            this.onLoad(this.page);
        },
        searchChange (params, done) {
            this.query = params;
            this.page.currentPage = 1;
            this.onLoad(this.page, params);
            done();
        },
        selectionChange (list) {
            this.selectionList = list;
        },
        selectionClear () {
            this.selectionList = [];
            this.$refs.crud.toggleSelection();
        },
        handleDelete (event, id) {
            var ids = id ? [id] : this.selectionList.map(item => {
                return item.reportId
            })
            if (ids.length === 0) {
                this.$message.warning("请选择至少一条数据");
                return;
            }
            this.$confirm("确定将选择数据删除?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    return this.$request.processResp(() => remove(ids), () => this.onLoad(this.page), () => this.$refs.crud.toggleSelection(), () => { })
                });
        },
        currentChange (currentPage) {
            this.page.currentPage = currentPage;
        },
        sizeChange (pageSize) {
            this.page.pageSize = pageSize;
        },
        refreshChange () {
            this.onLoad(this.page, this.query);
        },
        onLoad (page, params = {}) {
            this.loading = true;
            getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
                if(res.data.code=="0"){
                    const data = res.data.data;
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                }
            });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/report/reportlist.vue